export interface ReclaimInstallAppPromptSuppressionInput {
  activeSetupTaskId?: string | null;
  setupGuideLoading?: boolean;
  showSetupGuideIntake?: boolean;
  walkthroughActive?: boolean;
}

export function shouldSuppressReclaimInstallAppPrompt({
  activeSetupTaskId,
  setupGuideLoading,
  showSetupGuideIntake,
  walkthroughActive,
}: ReclaimInstallAppPromptSuppressionInput): boolean {
  return (
    setupGuideLoading === true ||
    showSetupGuideIntake === true ||
    walkthroughActive === true ||
    activeSetupTaskId != null
  );
}
